"use strict";

exports.__esModule = true;
exports.default = void 0;

var _tooltip = require("./tooltip");

var _tooltip2 = require("../../directives/tooltip");

var _plugins = require("../../utils/plugins");

var components = {
  BTooltip: _tooltip.default
};
var plugins = {
  BTooltipDirectivePlugin: _tooltip2.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components,
    plugins: plugins
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/tooltip/index.js
// module id = 523
// module chunks = 0